import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const TermsAndConditions = () => import('./views/Index.vue');

export default [
  {
    path: '/terms-and-conditions',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'TermsAndConditions',
        component: TermsAndConditions,
        meta: { title: i18n.global.t('settings.termsAndConditions') },
      },
    ],
  },
];
